module.exports = __webpack_public_path__ + "static/media/london.1ecbac97.jpg";